export default __webpack_public_path__ + "static/media/skateboard_light.2182fe71.png";